// import React, { useState } from "react";
// import {
//   // Container,
//   Box,
//   Paper,
//   Stack,
//   Toolbar,
//   Typography,
//   Button,
// } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";

// import Papa from "papaparse";
// import moment from "moment";
// import { message } from "antd";
// import csvtojson from "csvtojson";
// import { uploadCampaignCSV } from "../../redux/features/clicksSlice";

// function CampaignUploadCsv() {
//   const dispatch = useDispatch();
//   const [csvData, setcsvdata] = useState({});

//   const resetAll = (level) => {
//     // setShowCsvData("");
//     // setStats({ count: 0, Payout_sum: 0, Points_posted: 0 });
//     setcsvdata({});
//   };

//   const onChange = (e) => {
//     let reader = new FileReader();
//     // resetAll(4);
//     // processcsv(e.target.files[0])
//     // console.log(reader.result, "resi;t");
//     reader.onload = async ({ target }) => {
//       // Use reader.result

//       const csv = Papa.parse(target.result, {
//         header: true,
//       });
//       // console.log(csv, "csv");
//       const parsedData = csv?.data;
//       // console.log(parsedData, "reader.result");
//       //   console.log(reader.result, "reader.result");
//       replaceheader(target.result, parsedData);
//     };
//     reader.readAsText(e.target.files[0]);
//     // setCsvFile(e.target.files[0])
//     // let reader = new FileReader();
//     message.success("Upload Successfuly!");
//   };

//   const replaceheader = (data, parsedData) => {
//     // with String
//     // let header = "";
//     // if (!data) return;
//     // console.log(data, "data-------");
//     const header = Object.keys(parsedData[0]);
//     // console.log(header, "header-----");
//     let csv_head = [];
//     let notpresent = [];
//     let validKeys = [];
//     // console.log(Object.entries(csv_head), "Object.entries(csv_head)");
//     for (let [key, value] of Object.entries(csv_head)) {
//       if (
//         !value ||
//         value == "null" ||
//         key == "date" ||
//         key == "network" ||
//         key == "loginid" ||
//         key == "campaign"
//       )
//         continue;
//       value = value.trim();
//       console.log(value, "value");
//       if (header.includes(value)) {
//         validKeys.push(key);
//         let index = header.indexOf(value);
//         header[index] = key;
//       } else notpresent.push(key);
//     }
//     if (notpresent.length)
//       return message.error(
//         "following fields are not present in csv :" + notpresent.toString(),
//         10
//       );
//     processcsv(data, header, validKeys);
//   };
//   const processcsv = (data, headers, validKeys) => {
//     let final_data = [];
//     const conversions = csvtojson({
//       noheader: false,
//       headers: headers,
//     })
//       .fromString(data)
//       .then((jsonObj) => {
//         console.log(jsonObj, "jsonObj");
//         jsonObj.forEach((element) => {
//           Object.keys(element).forEach(
//             (key) => validKeys.includes(key) || delete element[key]
//           );
//           // console.log(element, "element");
//           final_data.push(element);
//         });
//         // console.log(final_data, "final_data");
//         setcsvdata(final_data);
//       });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // document.getElementById("error").innerHTML = "";
//     // document.getElementById("success").innerHTML = "";
//     // console.log(csvData, "csvData");
//     let formData = new FormData();
//     formData.append("data", JSON.stringify(csvData));

//     dispatch(uploadCampaignCSV(formData));
//     cb();
//   };
//   const cb = (data) => {
//     console.log(data, "uploadCampaignCSV cb");
//     // if (data?.error) document.getElementById("error").innerHTML = data?.error;
//     // if (data?.success)
//     //   document.getElementById("success").innerHTML = data?.success;
//   };

//   return (
//     <>
//       <Paper elevation={3}>
//         <Stack spacing={3} direction={"column"}>
//           <Toolbar
//             mt={3}
//             sx={{
//               padding: "1.2rem",
//               borderBottom: "2px solid var(--primary-color)",
//             }}
//           >
//             <Typography
//               variant="h5"
//               component="tableTitle"
//               sx={{ flex: "1 1 100%", color: "var(--primary-color)" }}
//             >
//               {" "}
//               Upload Campaingn Report Csv
//             </Typography>
//             {/* <NavLink to="/campaigns/csv_report">
//               <Button
//                 variant="contained"
//                 color="info"
//                 sx={{ whiteSpace: "nowrap" }}
//                 startIcon={<ReplyIcon />}
//               >
//                 <strong>Csv Report</strong>
//               </Button>
//             </NavLink> */}
//           </Toolbar>
//           <Box>
//             {/* <Button
//               variant="contained"
//               color="info"
//               sx={{ whiteSpace: "nowrap" }}
//             >
//               Upload Csv
//             </Button> */}
//             <form className="row g-3">
//               <div className="form-group col-12 col-lg-12 my-3 text-center">
//                 {/* <label for="exampleFormControlFile1">Upload CSV</label> */}
//                 <input
//                   type="file"
//                   accept=".csv"
//                   className="form-control-file ml-3"
//                   id="exampleFormControlFile1"
//                   onChange={onChange}
//                 />
//               </div>

//               <div className="col-12 col-lg-12 my-3 text-center">
//                 <button
//                   type="submit"
//                   className="btn btn-primary"
//                   onClick={handleSubmit}
//                 >
//                   Submit
//                 </button>
//               </div>
//             </form>
//           </Box>
//         </Stack>
//       </Paper>
//     </>
//   );
// }

// export default CampaignUploadCsv;

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Paper,
  Stack,
  Toolbar,
  Typography,
  Button,
  styled,
  Grid,
  // Link,
} from "@mui/material";
import { useDispatch } from "react-redux";

import Papa from "papaparse";
import { message } from "antd";
import { uploadCampaignCSV } from "../../redux/features/clicksSlice";
import { z } from "zod";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { DataGrid } from "@mui/x-data-grid";
import { Helmet } from "react-helmet";
const columns = [
  { field: "date", headerName: "Date", width: 150 },
  { field: "network", headerName: "Network", width: 150 },
  { field: "loginId", headerName: "Login ID", width: 200 },
  { field: "campaign", headerName: "Campaign", width: 180 },
  { field: "clicks", headerName: "Clicks", width: 120 },
  { field: "conversions", headerName: "Conversions", width: 120 },
  { field: "payout", headerName: "Payout", width: 150 },
  // { field: "pending", headerName: "Pending", width: 120 },
  { field: "cancelled", headerName: "Cancelled", width: 120 },
  { field: "approved", headerName: "Approved", width: 120 },
  {
    field: "cancelled_conversion",
    headerName: "Cancelled Conversion",
    width: 180,
  },
  {
    field: "approved_conversion",
    headerName: "Approved Conversion",
    width: 180,
  },
  { field: "usd", headerName: "USD", width: 120 },
  { field: "eur", headerName: "EUR", width: 120 },
];

function CampaignUploadCsv() {
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const [csvData, setCsvData] = useState([]); // Use array instead of object
  const [validationErrors, setValidationErrors] = useState([]);

  const dateSchema = z.string().regex(
    /^([0][1-9]|[12][0-9]|3[01])[-\/]([0][1-9]|1[0-2])[-\/]([0-9]{2}|[0-9]{4})$/,
    "Date must be in dd-mm-yyyy, dd/mm/yyyy, dd-mm-yy or dd/mm/yy format"
  );

  const resetAll = () => {
    setCsvData([]);
    setRows([]);
    setValidationErrors([]);
  };

  // console.log(csvData, "csv data");

  const onChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      message.error("No file selected!");
      return;
    }

    let reader = new FileReader();
    reader.onload = async ({ target }) => {
      const csv = Papa.parse(target.result, {
        header: true,
        skipEmptyLines: true, // Avoid empty rows
      });

      if (!csv || !csv.data || csv.data.length === 0) {
        message.error("Invalid or empty CSV file!");
        return;
      }

      const errors = [];
      const validRows = [];

      csv.data.forEach((row, index) => {
        const rowDate = String(row.Date || row.date || "").trim();
        if (!dateSchema.safeParse(rowDate).success) {
          errors.push(
            `Row ${index + 1}: invalid date '${rowDate || "(empty)"}' (required mm/dd/yyyy)`
          );
          return;
        }

        // preserve mm/dd/yyyy exactly
        validRows.push({ ...row, Date: rowDate });
      });

      if (errors.length > 0) {
        setValidationErrors(errors);
        setCsvData([]);
        setRows([]);
        message.error(
          `Date validation failed on ${errors.length} row(s). Check errors below.`
        );
        console.error("CSV date validation errors:", errors);
        return;
      }

      setValidationErrors([]);
      setCsvData(validRows);
      message.success("CSV uploaded successfully and all dates are valid!");
    };

    reader.readAsText(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (csvData.length === 0) {
      message.error("No data to upload!");
      return;
    }

    const submitErrors = [];
    csvData.forEach((row, index) => {
      const rowDate = String(row.Date || row.date || "").trim();
      if (!dateSchema.safeParse(rowDate).success) {
        submitErrors.push(
          `Row ${index + 1}: invalid date '${rowDate || "(empty)"}' (required mm/dd/yyyy)`
        );
      }
    });

    if (submitErrors.length > 0) {
      setValidationErrors(submitErrors);
      message.error("Cannot submit: date validation failed. Fix rows first.");
      return;
    }

    try {
      let formData = new FormData();
      // formData.append("data", JSON.stringify(csvData));
      formData.append(
        "csv",
        new Blob([Papa.unparse(csvData)], { type: "text/csv" }),
      );

      await dispatch(uploadCampaignCSV(formData))
        .unwrap()
        .then((res) => {
          message.success(res.message || "Uploaded successfully");
          resetAll();
        })
        .catch((err) => {
          console.log(err, "errr");
          message.error(err); // ← now shows MulterError message
        });

      // message.success("Data submitted successfully!");
      // resetAll();
    } catch (error) {
      message.error("Error uploading CSV!");
      console.error(error);
    }
  };

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const get = (row, key) => row[key] || row[key + "   "] || "";
  useEffect(() => {
    // Assuming csvData is the parsed CSV data from the uploaded file

    if (csvData.length > 0) {
      const parsedData = csvData.map((row, index) => ({
        id: index + 1, // Assigning a unique id to each row
        date: row.Date,
        network: row.Network,
        loginId: row["Login ID"],
        campaign: row.Campaign,
        clicks: row.Clicks,
        conversions: row.Conversions,
        payout: get(row, "Payout"),
        // pending: row.penging,
        cancelled: row.Cancelled,
        approved: row.Approved,
        cancelled_conversion: row["Cancelled Conversion"],
        approved_conversion: row["Approved Conversion"],
        usd: row.USD,
        eur: row.EUR,
      }));
      setRows(parsedData);
    }
  }, [csvData]);

  const today = new Date();

  const formatted =
    String(today.getDate()).padStart(2, "0") +
    "-" +
    String(today.getMonth() + 1).padStart(2, "0") +
    "-" +
    today.getFullYear();

 

  const handleDownload = () => {
    const csvData = [
      [
        "Date",
        "Network",
        "Login ID",
        "Campaign",
        "Clicks",
        "Conversions",
        "Payout",
        "Cancelled",
        "Approved",
        "Cancelled Conversion",
        "Approved Conversion",
        "USD",
        "EUR",
      ],
      [
        formatted,
        "sample network",
        "sample@gmail.com",
        "sample campaign",
        342,
        54,
        452,
        34,
        45,
        200,
        234,
        434,
        434,
      ],
    ];

    const csvContent = csvData.map((row) => row.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "sample.csv";
    document.body.appendChild(link); // Append the link to the DOM
    link.click(); // Trigger the download
    document.body.removeChild(link); // Clean up
    URL.revokeObjectURL(url); // Release the object URL
  };

  return (
    <>
      <Helmet>
        <title>Alpha Targeting || Csv Upload</title>
      </Helmet>
      <Paper elevation={3} sx={{ padding: 2 }}>
        <Stack spacing={3} direction={"column"}>
          <Toolbar
            sx={{
              padding: "1.2rem",
              borderBottom: "2px solid var(--primary-color)",
            }}
          >
            <Typography
              variant="h5"
              sx={{ flex: "1 1 100%", color: "var(--primary-color)" }}
            >
              Upload Campaign Report CSV
            </Typography>
          </Toolbar>
          <Box>
            <form
              style={{
                padding: 4,
                // border: "2px solid red",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* <div className="form-group col-12 my-3 text-center">
              <input
                type="file"
                accept=".csv"
                className="form-control-file"
                onChange={onChange}
              />
            </div> */}
              <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
                // size="small"
                // sx={{ width: "200px" }}
              >
                Upload files
                <VisuallyHiddenInput
                  accept=".csv"
                  type="file"
                  onChange={onChange}
                  multiple
                />
              </Button>
            </form>

            {/* <Button
            variant="contained"
            color="primary" 
            component="a"
            href="file/sample.csv"
            download="sample.csv"
            onClick={handleDownload}
          > */}
            <Typography
              onClick={handleDownload}
              component={"h6"}
              variant="body2"
              sx={{
                my: 1,
                cursor: "pointer",
                textAlign: "center",
                width: "100%",
                // border: "2px solid red",
              }}
            >
              Download the <span style={{ color: "#1976d2" }}>example CSV</span>{" "}
              file to view the required format.
            </Typography>
            {/* </Button> */}
          </Box>
        </Stack>

        {/* table s */}

        {validationErrors.length > 0 && (
          <Box sx={{ mt: 2, p: 2, border: "1px solid red", borderRadius: 2 }}>
            <Typography variant="subtitle2" color="error">
              Date validation errors:
            </Typography>
            <ul>
              {validationErrors.slice(0, 10).map((err, idx) => (
                <li key={idx} style={{ color: "#b71c1c" }}>
                  {err}
                </li>
              ))}
              {validationErrors.length > 10 && (
                <li>...and {validationErrors.length - 10} more.</li>
              )}
            </ul>
          </Box>
        )}

        {csvData.length > 0 && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div style={{ height: 300, width: "100%" }}>
                <DataGrid rows={rows} columns={columns} pageSize={5} />
              </div>
            </Grid>
          </Grid>
        )}

        {csvData.length > 0 && (
          <div className="col-12 my-3 text-center">
            <button
              type="submit"
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        )}
      </Paper>
    </>
  );
}

export default CampaignUploadCsv;
